// @flow
import { combineReducers } from 'redux';
import { success } from 'app/actions';

import app from 'app/appReducer';
import lang from 'app/lang/langReducer';
import login from 'login/loginReducer';
import configuration from 'configuration/configurationReducer';
import controlPanel from 'control-panel/controlPanelReducer';
import classesStudents from 'classes-students/classesStudentsReducer';
import editClass from 'classes-students/edit/editClassReducer';
import profiles from 'profiles/profilesReducer';
import addProfile from 'add-profile/addProfileReducer';
import register from 'register/registerReducer';
import reports from 'reports/reportsReducer';
import reportApplication from 'reports/application/reportApplicationReducer';
import reportGeneralPanel from 'reports/general-panel/reportGeneralPanelReducer';
import reportGeneralTRIPanel from 'reports/general-panel-tri/reportGeneralPanelTRIReducer';
import reportApplicationDetails from 'reports/application-detail/reportApplicationDetailsReducer';
import simulated from 'simulated/simulatedReducer';
import simulatedEdition from 'simulated/simulated-edition/simulatedEditionReducer';
import simulatedContentMap from 'simulated/content-map/simulatedContentMapReducer';
import simulatedCorrection from 'simulated/correction/simulatedCorrectionReducer';
import simulatedQuestions from 'simulated/questions/simulatedQuestionsReducer';
import studentSimulated from 'student-simulated/studentSimulatedReducer';
import onlineSimulated from 'online-simulated/onlineSimulatedReducer';
import units from 'units/unitsReducer';
import changePassword from 'changePassword/changePasswordReducer';
import composingCorrection from 'simulated/composing-correction/composingCorrectionReducer';
import managerDashboard from 'reports/manager-dashboard/managerDashboardReducer';
import networkPanel from 'reports/network-panel/networkPanelReducer';

import * as loginActions from 'login/loginActions';

const appReducer = combineReducers({
  app,
  lang,
  login,
  configuration,
  controlPanel,
  classesStudents,
  editClass,
  profiles,
  addProfile,
  register,
  reports,
  reportApplication,
  reportGeneralPanel,
  reportApplicationDetails,
  simulated,
  simulatedContentMap,
  simulatedCorrection,
  simulatedQuestions,
  simulatedEdition,
  studentSimulated,
  onlineSimulated,
  units,
  changePassword,
  reportGeneralTRIPanel,
  composingCorrection,
  managerDashboard,
  networkPanel,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === success(loginActions.LOGOUT)) {
    return appReducer(undefined, action); // reset the state when user logouts
  }
  return appReducer(state, action);
};

export default rootReducer;
